export default "__VITE_ASSET__99946411__"